import React, { useState, useEffect , useRef} from 'react';  
import ContentLoader from 'react-content-loader'; // Optional, but recommended
import { useNavigate, useLocation, useParams  } from 'react-router-dom';
import { useLanguage } from './language/LanguageContext';
import LanguageSelector from './language/LanguageSelector';
import { faArrowLeft, faCheck,faClock, faTimes,faLocationPin,faPhone, faMapMarkerAlt,faTruck,faMap} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ListView from './images/listView.png';
import GST from './images/gst.png';
import Roff from './images/roff.png';
import BoxHourGlass from './images/orderDetails_icons/box_hourglass.png';
import BoxCheck from './images/orderDetails_icons/box_check.png';
import BoxArrow from './images/orderDetails_icons/box_rightarrow.png';
import CounterOffer from './images/orderDetails_icons/counter_offer.png';
import Boxx from './images/orderDetails_icons/box_x.png';
import Medal from './images/orderDetails_icons/first_medal.png';
import Scooter from './images/orderDetails_icons/scooter_bag.png';
import Shipped from './images/orderDetails_icons/shipped.png';
import BoxReturn from './images/orderDetails_icons/box_return.png';
import Phone from './images/orderDetails_icons/phone.png';
import Whatsapp from './images/orderDetails_icons/whatsapp.png';
import Snackbar from './components/Snackbar';
import { useNotification } from '../context/NotificationContext';
import ArrowLeft from './images/ArrowLeft.png';
import AwardedCard from './ReusableComponents/AwardedCard'; 
import UploadInvoiceModal from './ReusableComponents/UploadInvoiceModal';
import ItemsReadyModal from './ReusableComponents/ItemsReadyModal';
import CustomPopup  from './ReusableComponents/CustomPopup';
import OrderItemsAvailabilityBottomSheet from './ReusableComponents/OrderDetaillsBottomSheets';
import Default from './images/default_img.png';
import BB from './images/BB.png';
const phoneNumber = "8247895454";
const whatsappNumber = "918247895454"; // with country code




// Create a custom Skeleton Loader
const OrderDetailsSkeleton = (props) => (
  <ContentLoader 
    speed={2}
    width="100%"
    height={600}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    {/* Order Header Skeleton */}
    <rect x="0" y="0" rx="10" ry="10" width="100%" height="80" /> 
    
    {/* Status Card Skeleton */}
    <rect x="10" y="100" rx="10" ry="10" width="95%" height="120" />
    
    {/* Items Header */}
    <rect x="10" y="250" rx="4" ry="4" width="200" height="20" />
    
    {/* Multiple Item Skeletons */}
    {[0, 1, 2].map((item, index) => (
      <React.Fragment key={index}>
        <rect 
          x="10" 
          y={300 + index * 100} 
          rx="10" 
          ry="10" 
          width="95%" 
          height="80" 
        />
      </React.Fragment>
    ))}
    
    {/* Bill Details Skeleton */}
    <rect x="10" y="600" rx="10" ry="10" width="95%" height="150" />
  </ContentLoader>
);


const DeliveryValidationModal = ({ visible, onClose }) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-auto">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-gray-900 text-center mb-2">
            Delivery Validation Required
          </h3>
          <p className="text-gray-600 text-center mb-6">
            Please select Delivery Included and Delivery Time before submitting.
          </p>
          <div className="flex justify-center">
            <button
              onClick={onClose}
              className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-6 rounded-md transition duration-200"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Animated Loading Spinner Component
const LoadingSpinner = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
    <div className="relative">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div className="animate-spin w-16 h-16 border-4 border-[#F43042] border-t-transparent rounded-full animate-spin"></div>
      </div>
      <div className="mt-24 text-center">
        <p className="text-[#524D4D] font-medium animate-pulse">
          Loading Order Details...
        </p>
      </div>
    </div>
  </div>
);

// Progress Loader Component
const ProgressLoader = ({ progress }) => (
  <div className="fixed top-0 left-0 right-0 z-50">
    <div 
      className="h-1 bg-[#F43042]" 
      style={{ 
        width: `${progress}%`, 
        transition: 'width 0.5s ease-in-out' 
      }}
    ></div>
  </div>
);

function OrderDetails() {
      const location = useLocation();
      const params = useParams();
      // Try getting from state first
const quotationIdFromState = location.state?.quotationId;

// Then try from query string (?quotationId=...)
const searchParams = new URLSearchParams(location.search);
const quotationIdFromQuery = searchParams.get('quotationId');
      //const quotationId = location.state?.quotationId? location.state?.quotationId : params.quotationId;
     const quotationId = quotationIdFromState || quotationIdFromQuery;
      console.log('Quotation ID:', quotationId);
      const vendorid = location.state?.vendor_id;
      console.log('Quotation ID:', quotationId);
      console.log('Vendor ID:', vendorid);
      const navigate = useNavigate();
      const { language } = useLanguage();
      const [order , setOrder] = useState(null);
         const [snackbarState, setSnackbarState] = useState({
         show: true,
         minimized: false
       });
      const [menuOpen, setMenuOpen] = useState(false);
  const [orderAccepted, setOrderAccepted] = useState(false);
  const [isProposingAmendments, setIsProposingAmendments] = useState(false);
  const [amendedItems, setAmendedItems] = useState([]);
const [timeRemaining, setTimeRemaining] = useState(null);
const [isExpired, setIsExpired] = useState(false);
const [isCounterOfferModalOpen, setIsCounterOfferModalOpen] = useState(false);
const [isCounterOfferMode, setIsCounterOfferMode] = useState(false);
const [PriceValidityModalOpen, setPriceValidityModalOpen] = useState(false);
const [priceValidityOption, setPriceValidityOption] = useState(''); 
const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);
const [skipOrderReasonsModal, setSkipOrderReasonsModal] = useState(false);
const [selectedSkipReason, setSelectedSkipReason] = useState(null);
const [isCounterOffer, setIsCounterOffer] = useState(false);
const { notifications, setNotifications } = useNotification();
//console.log('Notifications:', notifications);
const [showNavigationWarningModal, setShowNavigationWarningModal] = useState(false);
const [loader, setLoader] = useState(true);
const [loadingProgress, setLoadingProgress] = useState(0);
const [itemsReadyPopup , setItemsReadyPopup] = useState(false);
const [isUpdatingDeliveryStatus, setIsUpdatingDeliveryStatus] = useState(false);
const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
const [otpValues, setOtpValues] = useState(['', '', '', '']);
const [isVerifyingOTP, setIsVerifyingOTP] = useState(false);
const [allUOMs, setAllUOMs] = useState([]);
const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
 const [deliveryTime , setDeliveryTime] = useState(null);
const [deliveryIncluded, setDeliveryIncluded] = useState("Yes"); // default Yes
const [showValidationModal, setShowValidationModal] = useState(false);
const [popupMessage, setPopupMessage] = useState('');
const [loadingBill, setLoadingBill] = useState(false);
const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [uploadInvoicePopup, setUploadInvoicePopup] = useState(false);
const [billData, setBillData] = useState(null);
  const [selectedTime, setSelectedTime] = useState("Not Provided");
const [showSheet, setShowSheet] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);




// Add refs for OTP inputs
const otpRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const snackbarRef = useRef(null);

  const minimizeSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, minimized: true }));
  };
  
  const expandSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, minimized: false }));
  };
  
  const hideSnackbar = () => {
    setSnackbarState({ show: false, minimized: false });
  };

    // Simulate loading progress
  useEffect(() => {
    if (loader) {
      const progressInterval = setInterval(() => {
        setLoadingProgress(prevProgress => {
          if (prevProgress >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prevProgress + 10;
        });
      }, 500);

      return () => clearInterval(progressInterval);
    }
  }, [loader]);

 useEffect(() => {
  if (quotationId) {
    fetchQuotationbyId();
  }
  }, [quotationId]);

  useEffect(() => {
  fetchAllUOMs();
}, []);

  useEffect(() => {
  if (order && order.order_created_at && order.order_waiting_time) {
    const startTime = new Date(order.order_created_at);
    const expirationTime = new Date(startTime.getTime() + order.order_waiting_time * 60 * 1000); // Convert minutes to milliseconds
    const now = new Date();

    // Check if the order is already older than the waiting time
    if (now >= expirationTime) {
      setIsExpired(true);
      setTimeRemaining(null);
      return;
    }

    const timer = setInterval(() => {
      const currentTime = new Date();
      const difference = expirationTime - currentTime;

      if (difference <= 0) {
        clearInterval(timer);
        setIsExpired(true);
        setTimeRemaining(null);
      } else {
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);
        setTimeRemaining({ minutes, seconds });
      }
    }, 1000);

    return () => clearInterval(timer);
  }
}, [order]);


// Checks notification that are matches with the order id and updates the states in the UI
/*  useEffect(() => {
  // Check if we have notifications and an order
  if (notifications && notifications.length > 0 && order) {
    // Filter notifications that match the current order ID
    const matchingNotifications = notifications.filter(notification => 
      notification.data?.order_id.replace(/"/g, '') === order._id
    );

    // If we have matching notifications, find the most recent one
    if (matchingNotifications.length > 0) {
      const mostRecentNotification = matchingNotifications.reduce((latest, current) => 
        new Date(current.timestamp) > new Date(latest.timestamp) ? current : latest
      );

      // Update order status from the most recent notification
      const newStatus = mostRecentNotification.data.order_status || mostRecentNotification.data.vendor_response_status;

      // Only update if the status is different
      if (newStatus && newStatus !== order.vendor_status) {
        // Create a new order object with updated status
        const updatedOrder = {
          ...order,
          vendor_status: newStatus
        };

        // Update the order state
        setOrder(updatedOrder);

        console.log('Order status updated from notification:', {
          oldStatus: order.vendor_status,
          newStatus: newStatus
        });
      }
    }
  }
}, [notifications, order]);  */

// Checks notification that are matches with the order id and updates the awarded states in the UI
/* useEffect(() => {
  // Check if we have notifications and an order
  if (notifications && notifications.length > 0 && order) {
    // Filter notifications that match the current order ID
    const matchingNotifications = notifications.filter(notification =>
      notification.data?.order_id.replace(/"/g, '') === order._id
    );

    // If we have matching notifications, find the most recent one
    if (matchingNotifications.length > 0) {
      const mostRecentNotification = matchingNotifications.reduce((latest, current) =>
        new Date(current.timestamp) > new Date(latest.timestamp) ? current : latest
      );

      // Extract status from notification
      const newStatus = mostRecentNotification.data.order_status || 
                        mostRecentNotification.data.vendor_response_status;

      // Prepare update object
      const updateObject = {};
      let shouldUpdate = false;

      // Check status update
      if (newStatus && newStatus.toLowerCase() !== order.vendor_status?.toLowerCase()) {
        updateObject.vendor_status = newStatus;
        shouldUpdate = true;
      }

      // Special handling for Awarded status
      if (newStatus && newStatus.toLowerCase() === 'awarded') {
        // Get current fulfillment status, defaulting to null if not exists
        const currentFulfillmentStatus = order.in_fulfillment_status 
          ? order.in_fulfillment_status.toLowerCase() 
          : null;

        // Conditions to set "In Progress"
        const shouldSetInProgress = 
          currentFulfillmentStatus === null || 
          currentFulfillmentStatus === 'not started';

        // Set in_fulfillment_status to 'In Progress' if conditions are met
        if (shouldSetInProgress) {
          updateObject.in_fulfillment_status = 'In Progress';
          shouldUpdate = true;
        }
      }

      // Perform update if changes detected
      if (shouldUpdate) {
        const updatedOrder = {
          ...order,
          ...updateObject
        };

        setOrder(updatedOrder);

        console.log('Order updated from notification:', {
          oldStatus: order.vendor_status,
          newStatus: newStatus,
          oldFulfillmentStatus: order.in_fulfillment_status,
          newFulfillmentStatus: updateObject.in_fulfillment_status,
          changes: Object.keys(updateObject)
        });
      }
    }
  }
}, [notifications, order]);
 */

//Checks the notification and if order id matches then fetch quotation by id will gets called.
useEffect(() => {
  // Check if we have notifications and an order
  if (notifications && notifications.length > 0 && order) {
    // Filter notifications that match the current order ID
    const matchingNotifications = notifications.filter(notification =>
      notification.data?.order_id?.replace(/"/g, '') === order._id
    );

    // If we have matching notifications, fetch fresh data
    if (matchingNotifications.length > 0) {
      console.log('Found matching notification for current order, fetching fresh data:', {
        orderId: order._id,
        notificationCount: matchingNotifications.length,
        timestamp: new Date().toISOString()
      });
      
      // Fetch fresh data from server
      fetchQuotationbyId();
    }
  }
}, [notifications]);

  // Helper function to get items by category
const getItemsByCategory = (categoryId) => {
  return order.items.filter(item => item.item_category_id === categoryId);
};
/* const fetchQuotationbyId = async () => {
  try {
    setIsCounterOfferMode(false);
          setLoader(true);
      setLoadingProgress(0);
    // Parse vendorData from localStorage
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      return;
    }
    
    const vendorData = JSON.parse(vendorDataString);
    
    const token =  vendorData.token;
    
    // Fetch quotations for this vendor
   const response = await fetch(
  `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-suplier-quotation-by-its-id?quotation_id=${quotationId}&vendor_id=${vendorData.id}`,
  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-token': token,
    },
  }
);

    const data = await response.json();
    console.log('Quotations data:', data);
          // Simulate network delay for better UX
      await new Promise(resolve => setTimeout(resolve, 1000));
    if (data.success) {
      // Update the orders state with the formatted data
      setOrder(data.data);
       setLoadingProgress(100);
      } else {
        console.error('Failed to fetch quotations');
      }
    } catch (error) {
      console.error('Error fetching quotations:', error);
    } finally {
      // Ensure loader is set to false
      setTimeout(() => {
        setLoader(false);
      }, 500);
    }
  }; */


const fetchQuotationbyId = async () => {
  try {
    setIsCounterOfferMode(false);
    setLoader(true);
    setLoadingProgress(0);

    const vendorDataString = localStorage.getItem("vendorData");
    if (!vendorDataString) return console.error("No vendor data found");

    const vendorData = JSON.parse(vendorDataString);
    const token = vendorData.token;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/purchaseorder/get-supplier-order-details?order_id=${quotationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();
    console.log("Quotations data:", data);

    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (data.success) {
      setOrder(data.data);

      // ✅ set delivery included & time from backend
      
    // ✅ Handle delivery included mapping
if ("delivery_included" in data.data) {
  const included = data.data.delivery_included;

  if (included === true) {
    setDeliveryIncluded("Yes");
  } else if (included === false) {
    setDeliveryIncluded("No");
  } else {
    setDeliveryIncluded("Yes"); // fallback if null/invalid
  }
} else {
  setDeliveryIncluded("Yes"); // default if field is missing
}


      // ✅ handle delivery time (convert number → label)
      if (data.data.delivery_time_in_hours != null) {
        setDeliveryTime(data.data.delivery_time_in_hours);
      } else {
        setDeliveryTime(null);
      }

      setLoadingProgress(100);
    } else {
      console.error("Failed to fetch quotations");
    }
  } catch (error) {
    console.error("Error fetching quotations:", error);
  } finally {
    setTimeout(() => setLoader(false), 500);
  }
};

const handleDeliveryTimeChange = (time) => {
  const numericValue = parseInt(time);
  setDeliveryTime(numericValue); 
  
  console.log("User selected delivery time:", numericValue);
};



  // Add this handler for the Accept Order button
 // Add this function after the fetchQuotationbyId function
const updateVendorStatus = async (status, notes = '') => {
  // 🚨 validation before API call
 /*  if (!deliveryIncluded || !deliveryTime || parseInt(deliveryTime) === 0) {
    alert("Please select both 'Delivery Included?' and 'Delivery Time' before submitting.");
    return false; // stop execution
  } */
  try {    
    // Parse vendorData from localStorage
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      return;
    }
    
    const vendorData = JSON.parse(vendorDataString);
    const vendorResponse = await handleVendorResponseData(order, status, vendorData);
    console.log(order);
    console.log(vendorResponse);
    const token = vendorData.token;
    const vendor_id = vendorData.vendor_id || vendorData.id; // Adjust based on your vendor data structure
    
    // Call the update status API
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/submits-supplier-response-on-an-order?quotation_id=${quotationId}`, 
      {
        method: 'PUT', // or 'PATCH' depending on your route
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          response_type: status,
          supplier_id: vendor_id,
          quotation_id:quotationId,
          message: notes,
          delivery_included: deliveryIncluded === "Yes" ? true : false,
          delivery_time_in_hours: deliveryTime ? parseInt(deliveryTime) : null,
          vendor_response: vendorResponse,
          items_response: vendorResponse.items,
        })
      }
    );

    const data = await response.json();
    console.log('Status update response:', data);
    
    if (data.success) {
      // Refresh the quotation data to get updated status
      fetchQuotationbyId();
      return true;
    } else {
      console.error('Failed to update status:', data.message);
      return false;
    }
  } catch (error) {
    console.error('Error updating vendor status:', error);
    return false;
  }
};

const handleVendorResponseData = async (order, status, vendorData) => {
  try {
    console.log('order:', order, 'status:', status);
    
    let items = [];
    let overallStatus = status;
    
    // Handle different status cases
    if (status === 'Accepted') {
      // For Accepted status: set all items to Accepted and return empty items array
      items = [];
      overallStatus = 'Accepted';
      
    } else if (status === 'Counter Offer') {
      // For Counter Offer: map items with proposed prices
      items = order.items.map(item => {
        const responseItem = {
          item_id: item.item_id || item._id,
          quantity: item.quantity,
          quotation_price: item.selling_price,
          item_status: 'Counter Offer',
          response_reason: 'Vendor proposed amendments to price/quantity'
        };
        
        // Add proposed price if it exists
        if (item.proposed_selling_price && item.proposed_selling_price !== item.selling_price) {
          responseItem.proposed_price = item.proposed_selling_price;
        }

        if (item.proposed_quantity && item.proposed_quantity !== item.quantity) {
          responseItem.quantity = item.proposed_quantity;
          responseItem.proposed_quantity = item.proposed_quantity;
        }
        
        return responseItem;
      });
      overallStatus = 'Counter Offer';
      
    } else if (status === 'rejected') {
      // For rejected status: map items with rejection reason
      items = order.items.map(item => ({
        item_id: item.item_id || item._id,
        quantity: item.quantity,
        quotation_price: item.selling_price,
        item_status: 'rejected',
        response_reason: 'Order rejected by vendor'
      }));
      overallStatus = 'rejected';
      
    } else if (status === 'Skipped') {
      // For skipped status: no need to process, return early or handle as needed
       items = [];
      overallStatus = 'Skipped';
      console.log('Order skipped by vendor');

    } else if (status === 'Shipped') {
      // For skipped status: no need to process, return early or handle as needed
       items = [];
      overallStatus = 'Shipped';
      console.log('Order Shipped');
    }
    
    // Create the vendor response data object
    const vendorResponseData = {
      quotation_id: order._id || quotationId,
      vendor_id: vendorData.vendor_id || vendorData.id,
      status_updated_at: new Date(),
      items: items,
      status: overallStatus
    };
    
    console.log('Vendor Response Data:', vendorResponseData);
    return vendorResponseData;
    
  } catch (error) {
    console.error('Error creating vendor response data:', error);
    return null;
  }
};



const handleAcceptOrder = async() => {
  /* if (!deliveryIncluded || !deliveryTime || parseInt(deliveryTime) === 0) {
      setShowValidationModal(true); // Show modal instead of alert
       return false
    } */
  setPriceValidityModalOpen(true);
}
// Update the handleAcceptOrder function
const handleConfirmResponse = async () => {
  let status, notes;
  
  if (isCounterOffer) {
    // For Counter Offer
    status = 'Counter Offer';
    notes = 'Order Proposed by vendor';
  } else {
    // For Regular Order Accept
    status = 'Accepted';
    notes = priceValidityOption;
  }

  const success = await updateVendorStatus(status, notes);
  
  if (success) {
    // Reset the modal and counter offer flag
    setPriceValidityModalOpen(false);
    setIsCounterOffer(false);
    
    if (isCounterOffer) {
      setOrderAccepted(true);
      setIsCounterOfferMode(false);
    }
  } else {
    // Handle error - maybe show a toast or alert
    console.error('Failed to update vendor status', success);
  }
};

const handlePriceValiditySubmit = () => {
  if (priceValidityOption) {
    // Process the selected option
    console.log('Selected Price Validity:', priceValidityOption);
    setPriceValidityModalOpen(false);
  } else {
    // Optional: Show an error or prevent submission
    alert('Please select a price validity option');
  }
}; 

// Add handlers for other buttons
const handleRejectOrder = async () => {
  const success = await updateVendorStatus('rejected', 'Order rejected by vendor');
  if (success) {
    // Maybe navigate back or show rejection confirmation
    alert('Order rejected successfully');
  } else {
    alert('Failed to reject order. Please try again.');
  }
};

const fetchAllUOMs = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${backendApiUrl}UOMs/get-all-UOMs`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
    const data = await response.json();
    console.log('Fetched UOMs:', data);

    if (data.status === 200 || data.status === 201) {
      setAllUOMs(data.data);
    } else {
      console.error("Failed to fetch UOMs:", data.message);
    }
  } catch (error) {
    console.error("Error fetching UOMs:", error);
  }
};

const handleSkipOrder = async () => {
 setSkipOrderReasonsModal(true);
};

const handleItemsReadyConfirmation = async () => {
 setItemsReadyPopup(true);
};
      

  // Function to update item price
  const updateItemPrice = (index, newPrice) => {
  const updatedItems = [...amendedItems];
  updatedItems[index] = {
    ...updatedItems[index],
    proposed_selling_price: newPrice,
    proposed_total: newPrice * (updatedItems[index].proposed_quantity || updatedItems[index].quantity)
  };
  setAmendedItems(updatedItems);
  /* const UpdatedOrderData = {...order};
  UpdatedOrderData.items[index].proposed_selling_price = newPrice;
  
  // Use proposed_quantity if available, otherwise use quantity
  const quantity = UpdatedOrderData.items[index].proposed_quantity || UpdatedOrderData.items[index].quantity;
  UpdatedOrderData.items[index].proposed_total = newPrice * quantity;
  
  // Calculate subtotal using proposed values or fallback to original values
  UpdatedOrderData.subtotal = UpdatedOrderData.items.reduce((sum, item) => {
    const itemQuantity = item.proposed_quantity || item.quantity;
    const itemPrice = item.proposed_selling_price || item.selling_price;
    const itemTotal = item.proposed_total || (itemQuantity * itemPrice);
    return sum + itemTotal;
  }, 0);

    UpdatedOrderData.tax_amount = UpdatedOrderData.items.reduce((sum, item) => {
    const itemQuantity = item.proposed_quantity || item.quantity;
    const itemPrice = item.proposed_selling_price || item.selling_price;
    const itemTotaltax = itemQuantity * itemPrice * item.tax_rate / 100;
    return sum + itemTotaltax;
  }, 0);
  
  // Calculate total (subtotal + tax)
  UpdatedOrderData.total = UpdatedOrderData.subtotal + UpdatedOrderData.tax_amount;
  console.log('Updated Order Data:', UpdatedOrderData);
   console.log('Updated items Data:', updatedItems);
  setOrder(UpdatedOrderData); */
  
};


  // Calculate total for amended order
  const calculateAmendedTotal = () => {
    const subtotal = amendedItems.reduce((sum, item) => 
      sum + (item.proposed_total || 0), 0);
    const taxRate = order?.tax_amount / order?.subtotal || 0.18; // Default to 18% if not found
    const taxAmount = subtotal * taxRate;
    
    return {
      subtotal,
      taxAmount,
      total: subtotal + taxAmount
    };
  };


// Function to update quantity
const updateCounterOfferQuantity = (index, change) => {
  const updatedItems = [...amendedItems];
  const currentQuantity = updatedItems[index].proposed_quantity;

  const maxQuantity = updatedItems[index].quantity; // Optional: restrict max if needed
  const newQuantity = Math.min(maxQuantity, Math.max(0, currentQuantity + change));

  updatedItems[index] = {
    ...updatedItems[index],
    proposed_quantity: newQuantity,
    proposed_total: newQuantity * updatedItems[index].proposed_selling_price
  };
  
  setAmendedItems(updatedItems);

    /* const UpdatedOrderData = {...order};
    const currentOrderQuantity = UpdatedOrderData.items[index].proposed_quantity;
    const newOrderQuantity = Math.max(1, currentOrderQuantity + change);
      UpdatedOrderData.items[index] = {
    ... UpdatedOrderData.items[index],
    proposed_quantity: newOrderQuantity,
    proposed_total: newOrderQuantity * UpdatedOrderData.items[index].proposed_selling_price
      };
       // Calculate subtotal using proposed values or fallback to original values
  UpdatedOrderData.subtotal = UpdatedOrderData.items.reduce((sum, item) => {
    const itemQuantity = item.proposed_quantity || item.quantity;
    const itemPrice = item.proposed_selling_price || item.selling_price;
    const itemTotal = item.proposed_total || (itemQuantity * itemPrice);
    return sum + itemTotal;
  }, 0);

    UpdatedOrderData.tax_amount = UpdatedOrderData.items.reduce((sum, item) => {
    const itemQuantity = item.proposed_quantity || item.quantity;
    const itemPrice = item.proposed_selling_price || item.selling_price;
    const itemTotaltax = itemQuantity * itemPrice * item.tax_rate / 100;
    return sum + itemTotaltax;
  }, 0);
  
  // Calculate total (subtotal + tax)
  UpdatedOrderData.total = UpdatedOrderData.subtotal + UpdatedOrderData.tax_amount;
  console.log('Updated Order Data:', UpdatedOrderData);
   console.log('Updated items Data:', updatedItems); */
 
  //setOrder(UpdatedOrderData);
};


 const handleProposeAmendments = () => {
  /* if (!deliveryIncluded || !deliveryTime || parseInt(deliveryTime) === 0) {
      setShowValidationModal(true); // Show modal instead of alert
       return false
    } */
  // Initialize amended items with the current order items
  if (order && order.items) {
 setAmendedItems(order.items.map(item => ({
     ...item,
   proposed_quantity: item.quantity,
   proposed_selling_price: item.selling_price,
   proposed_total: item.quantity * item.selling_price
})));


 const UpdatedOrderData = {
    ...order,
 items: order.items.map(item => ({
    ...item,
 proposed_quantity: item.quantity,
 proposed_selling_price: item.selling_price,
 proposed_total: item.quantity * item.selling_price
 }))
};
setOrder(UpdatedOrderData);


 //setIsProposingAmendments(true);
 setIsCounterOfferModalOpen(true);
 }
 };

const handleSaveAmendments= async() =>{
  const updateOrder = {...order};
  updateOrder.items = amendedItems;
 const FinalOrder= await calculateUpdateOrder(updateOrder);
 await setOrder(FinalOrder);
 console.log('Updated Order Data:', FinalOrder);
 if(FinalOrder){
  setIsCounterOfferModalOpen(false);
   setIsCounterOfferMode(true);
 }
}

const SaveProposedAmmendments = async () => {
  // Close Counter Offer Modal
  setIsCounterOfferModalOpen(false);
  
  // Open Price Validity Modal for Counter Offer
  setPriceValidityModalOpen(true);
  
  // Set a flag to indicate this is a counter offer
  setIsCounterOffer(true);
};

const calculateUpdateOrder = (updateOrder) => {
  // Calculate updated items with individual totals
  const updatedItems = updateOrder.items.map((item, index) => {
    const price =  item.proposed_selling_price > 0 ? item.proposed_selling_price : item.selling_price
    const quantity = item.proposed_quantity > 0 ? item.proposed_quantity : item.quantity
    const total_tax_amount = (item.tax_rate * price * quantity) / 100;
    
    return {
      ...item,
      total_tax_amount: Math.round(total_tax_amount),
      subtotal: Math.round(price* quantity),
      total: Math.round(price * quantity + total_tax_amount)
    };
  });
  
  // Calculate order-level totals
  const orderSubtotal = updatedItems.reduce((sum, item) => {
    return sum + item.subtotal;
  }, 0);
  
  const orderTaxAmount = updatedItems.reduce((sum, item) => {
    return sum + item.total_tax_amount;
  }, 0);
  
  const orderTotal = orderSubtotal + orderTaxAmount;
  
  // Return the complete updated order
  return {
    ...updateOrder,
    items: updatedItems,
    subtotal: Math.round(orderSubtotal),
    tax_amount: Math.round(orderTaxAmount),
    total: Math.round(orderTotal)
  };
};

// Add a handler for withdrawing acceptance
const handleWithdrawAcceptance = async () => {
  setIsWithdrawModalOpen(false);
};

const handleSkipOrderSubmit = () => {
  if (selectedSkipReason) {
    // Perform skip order logic here
    console.log('Skipping order with reason:', selectedSkipReason);
    updateVendorStatus('Skipped', selectedSkipReason );
    // Close the modal
    setSkipOrderReasonsModal(false);

    // Reset selected reason
    setSelectedSkipReason(null);
    // Reset selected reason
  }
};

const handleItemsReady = async () => {
  try {
    // Parse vendorData from localStorage
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      return false;
    }

    const vendorData = JSON.parse(vendorDataString);
    const status = 'Items Ready'; // Explicitly set status

    const token = vendorData.token;
    const vendor_id = vendorData.vendor_id || vendorData.id; // Adjust based on your vendor data structure

    // Call the update status API
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/update-fulfillment-status`,
      {
        method: 'PUT', // or 'PATCH' depending on your route
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          in_fulfillment_status: status,
          vendor_id: vendor_id,
          quotation_id: quotationId,
        })
      }
    );

    const data = await response.json();
    console.log('Status update response:', data);

    if (data.success) {
      // Refresh the quotation data to get updated status
      await fetchQuotationbyId();
      
      // Close the items ready popup
      setItemsReadyPopup(false);
      
      return true;
    } else {
      console.error('Failed to update status:', data.message);
      return false;
    }
  } catch (error) {
    console.error('Error updating vendor status:', error);
    return false;
  }
};

// Add this useEffect after your existing useEffects
// Update your useEffect
useEffect(() => {
  // Check if quotationIdFromQuery exists and order is awarded
  if (quotationIdFromQuery && order && order.status === 'Awarded' && order.in_fulfillment_status === 'Items Ready') {
    setIsUpdatingDeliveryStatus(true);
    handleDeliveryPartnerAssigned();
  }
}, [quotationIdFromQuery, order?.status, order?.in_fulfillment_status]);


// Add this new function to handle delivery partner assignment

// Update your handleDeliveryPartnerAssigned function
const handleDeliveryPartnerAssigned = async () => {
  try {
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      setIsUpdatingDeliveryStatus(false);
      return false;
    }

    const vendorData = JSON.parse(vendorDataString);
    const status = 'Delivery Partner Assigned';
    const token = vendorData.token;
    const vendor_id = vendorData.vendor_id || vendorData.id;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/update-fulfillment-status`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          in_fulfillment_status: status,
          vendor_id: vendor_id,
          quotation_id: quotationId,
        })
      }
    );

    const data = await response.json();
    console.log('Delivery Partner Assignment response:', data);

    if (data.success) {
      await fetchQuotationbyId();
      setIsUpdatingDeliveryStatus(false);
      return true;
    } else {
      console.error('Failed to update delivery partner status:', data.message);
      setIsUpdatingDeliveryStatus(false);
      return false;
    }
  } catch (error) {
    console.error('Error updating delivery partner status:', error);
    setIsUpdatingDeliveryStatus(false);
    return false;
  }
};

  const fetchOrderbyId = async () => {
    console.log('Fetching quotation details for ID:', quotationId);
    try {
      setIsCounterOfferMode(false);
      setLoader(true);

      const vendorDataString = await localStorage.getItem('vendorData');
      if (!vendorDataString) {
        console.error('No vendor data found in localStorage');
        return;
      }

      const vendorData = JSON.parse(vendorDataString);
      const token = vendorData.token;

      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/purchaseorder/get-supplier-order-details?order_id=${quotationId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        }
      );

      const data = await response.json();
      console.log('Order data:', data);

      if (data.success) {
        setOrder(data.data);
          // ✅ set delivery included & time from backend
      
    // ✅ Handle delivery included mapping
if ("delivery_included" in data.data) {
  const included = data.data.delivery_included;

  if (included === true) {
    setDeliveryIncluded("Yes");
  } else if (included === false) {
    setDeliveryIncluded("No");
  } else {
    setDeliveryIncluded("Yes"); // fallback if null/invalid
  }
} else {
  setDeliveryIncluded("Yes"); // default if field is missing
}


      // ✅ handle delivery time (convert number → label)
      if (data.data.delivery_time_in_hours != null) {
        setDeliveryTime(`${data.data.delivery_time_in_hours} hr`);
        setSelectedTime(`${data.data.delivery_time_in_hours} hr`);
      } else {
        setDeliveryTime(null);
      }
      } else {
        console.error('Failed to fetch order');
      }
    } catch (error) {
      console.error('Error fetching order:', error);
    } finally {
      setTimeout(() => {
        setLoader(false);
      }, 500);
    }
  };

  const UploadInvoice = async () => {
    try {
      setLoadingBill(true);
      const data = await FetchBillDetails();
      
      if (data) {
        setBillData(data);
        setUploadInvoicePopup(true);
      } else {
         // Show custom popup instead of alert
        setPopupMessage({
          title: 'Processing Bill',
          message: 'Kindly try after a while as we are processing the bill details.',
          type: 'warning'
        });
        setShowCustomPopup(true);
      }
     } catch (error) {
      console.error('Error fetching bill:', error);
      // Show error popup
      setPopupMessage({
        title: 'Error',
        message: 'Failed to load bill details. Please try again.',
        type: 'error'
      });
      setShowCustomPopup(true);
    } finally {
      setLoadingBill(false);
    }
  };

    const FetchBillDetails = async () => {
      try {
        const vendorDataString = await localStorage.getItem('vendorData');
        if (!vendorDataString) {
          console.error('No vendor data found in localStorage');
          return null;
        }
        const vendorData = JSON.parse(vendorDataString);
        const token = vendorData.token;
        
        const response = await fetch(
          `${process.env.REACT_APP_FORE_BRICKBUCKET}bill/get-bill-by-suborder-number?po_id=${order._id}`,
          { 
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'x-token': token,
            },
          }
        );
        
        const data = await response.json();
        console.log('Bill Details data:', data);
        
        if (data.success) {
          return data.data;
        } else {
          console.error('Failed to fetch bill:', data.message);
          return null;
        }
      } catch (error) {
        console.error('Error fetching bill:', error);
        return null;
      }
    };


const HandleWindowLoad = () => {
  window.location.reload();  
}

// OTP handling functions
const handleOTPChange = (index, value) => {
  // Only allow numeric input
  if (!/^\d*$/.test(value)) return;
  
  const newOtpValues = [...otpValues];
  newOtpValues[index] = value;
  setOtpValues(newOtpValues);
  
  // Auto-focus next input
  if (value && index < 3) {
    otpRefs[index + 1].current?.focus();
  }
};

const handleOTPKeyDown = (index, e) => {
  // Handle backspace to move to previous input
  if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
    otpRefs[index - 1].current?.focus();
  }
};

const handleVerifyOTP = async () => {
  const otpString = otpValues.join('');
  
  if (otpString.length !== 4) {
    alert('Please enter a complete 4-digit OTP');
    return;
  }
  
  setIsVerifyingOTP(true);
  
  try {
    // Add your OTP verification API call here
    const vendorDataString = localStorage.getItem('vendorData');
    const vendorData = JSON.parse(vendorDataString);
    
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/update-fulfillment-status`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': vendorData.token,
        },
        body: JSON.stringify({
          quotation_id: quotationId,
          vendor_id:  vendorData.id,
          in_fulfillment_status: 'Order Items Picked Up',
        })
      }
    );
    
    const data = await response.json();
    
    if (data.success) {
      // Close modal and refresh order data
      setIsOTPModalOpen(false);
      setOtpValues(['', '', '', '']);
      await fetchQuotationbyId();
      alert('OTP verified successfully!');
    } else {
      alert(data.message || 'Invalid OTP. Please try again.');
    }
  } catch (error) {
    console.error('Error verifying OTP:', error);
    alert('Error verifying OTP. Please try again.');
  } finally {
    setIsVerifyingOTP(false);
  }
};

const closeOTPModal = () => {
  setIsOTPModalOpen(false);
  setOtpValues(['', '', '', '']);
};



// Create a skeleton loader component for this specific case
const DeliveryStatusSkeleton = () => (
  <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
    <div className="w-full p-4 flex items-center justify-between animate-pulse">
      <div className="w-[75%] space-y-2">
        <div className="h-3 bg-gray-200 rounded w-3/4"></div>
        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
      </div>
      <div className="w-[35%]">
        <div className="h-8 bg-gray-200 rounded-md"></div>
      </div>
    </div>
  </div>
);

const handleNavigation = (source) => {
  switch(source) {
    case 'login':
      navigate('/supplier/home');
      break;
    case 'home':
      navigate('/supplier/home');
      break;
    case 'orders':
      navigate('/supplier/orders');
      break;
       case 'rfqs':
      navigate('/supplier/rfqs');
      break; 
        case 'rfqdetails':
      navigate('/supplier/rfqdetails', { state: { quotationId: quotationId } });
      break; 
         default:
      // Fallback to home if source is unknown
      navigate("/supplier/home");
      break;
  }
};


  const isEditable = order?.status === 'Respond Now' && !isExpired && !isCounterOfferMode;

  const handleItemNotAvailable  = () => {
  setShowSheet(true);
};

const handleAvailabilitySubmit = async (itemsPayload) => {
  console.log(itemsPayload);
  try {
    setIsSubmitting(true);

    const requestBody = {
      purchaseorderId: order._id, // <-- from route / state
      Items: itemsPayload,
    };

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/purchaseorder/mark-items-or-quantity-not-available-in-purchase-order`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      }
    );
    console.log(requestBody);

    const result = await response.json();
    console.log(result);

    if (!response.ok) {
      throw new Error(result?.message || "Failed to update availability");
    }

    // SUCCESS
    //setIsBottomSheetOpen(false);
    fetchOrderbyId(); // optional
  } catch (error) {
    console.error("Availability update error:", error);
  } finally {
    setIsSubmitting(false);
  }
};

  return (
     <>
    {/* STEP 4: GLOBAL LOADER (same as RFQDetails) */}
    {loader && <ProgressLoader progress={loadingProgress} />}
    {loader && <LoadingSpinner />}

    {/* STEP 5: CONDITIONAL RENDER */}
    {loader ? (
      <OrderDetailsSkeleton />
    ) : (
    <div className="flex flex-col min-h-screen bg-gray-100">

      {/* HEADER */}
      <div className="bg-white shadow-md border-b border-gray-100">
        <div className="flex flex-row items-center px-4 h-16">

          {/* Back Button */}
          <button
            onClick={() => navigate(-1)}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="text-xl" color="#374151" />
          </button>

          {/* Title */}
          <div className="flex-1 ml-3">
            <p className="text-lg font-bold text-gray-900">Order Details</p>
            <p className="text-sm text-gray-600 font-medium">
              {order?.order_number}
            </p>
          </div>
        </div>
      </div>

      {/* SCROLL VIEW */}
      <div className="flex-1 overflow-y-auto p-4">

        {/* Packing Pending */}
        {order?.status === "Order Confirmed" && (
          <AwardedCard order={order} />
        )}

        {/* Upload Invoice */}
        {order?.billing_status === "Ready To Bill" && (
          <div className="bg-white rounded-3 p-4 mb-3 shadow-sm">
            <div className="flex flex-row justify-between items-center">
              <p className="text-sm text-black font-medium mr-4">
                Check details and Upload Invoice
              </p>

              <button
                onClick={UploadInvoice}
                disabled={loadingBill}
                className="text-blue-500 text-xs font-semibold relative"
              >
                {loadingBill ? "Loading..." : "Click Here"}
                <div className="border-b border-dashed border-blue-500 absolute left-0 right-0 bottom-0" />
              </button>
            </div>
          </div>
        )}

        {/* Items Ready Button */}
        {order?.billing_status === "Billed" &&
          order?.status === "Order Confirmed" && (
            <div className="bg-white rounded-3 p-4 mb-3 shadow-sm">
              <div className="flex flex-row items-center justify-between">

                <p className="text-sm font-medium text-black mr-4">
                  Are order items ready for pickup?
                </p>

                <button
                  onClick={handleItemsReadyConfirmation}
                  className="bg-red-500 text-white rounded-2 py-2 px-4 font-semibold"
                >
                  Yes
                </button>
              </div>
              <div className="mt-2">
                <button
                  onClick={handleItemNotAvailable}
                  className="text-xs text-gray-500 underline hover:text-gray-700 transition"
                >
                  Click here if any item(s) are not available
                </button>
              </div>  
            </div>
          )}

        {/* Delivery Partner Notification */}
        {order?.status === "Ready For Delivery" &&
          order?.billing_status === "Billed" && (
            <div className="bg-green-100 rounded-3 p-4 mb-4 flex flex-row items-center">
              <img src={Scooter} className="w-12 h-12 mr-4" alt="scooter" />
              <p className="text-sm text-green-800 font-medium">
                Delivery Partner notified for pickup.
              </p>
            </div>
          )}

        {/* OTP Section */}
        {order?.vendor_status === "Awarded" &&
          !isUpdatingDeliveryStatus &&
          order?.in_fulfillment_status === "Delivery Partner Assigned" && (
            <div className="bg-orange-100 rounded-3 p-4 mb-4">
              <div className="flex flex-row items-center justify-between">
                <p className="text-sm text-orange-800 font-medium mr-4">
                  Get OTP from delivery partner to confirm pickup
                </p>

                <button
                  onClick={() => setIsOTPModalOpen(true)}
                  className="bg-orange-500 px-6 py-3 rounded-2 text-white font-semibold"
                >
                  Verify OTP
                </button>
              </div>
            </div>
          )}

        {/* Shipped */}
        {order?.vendor_status === "Awarded" &&
          order?.in_fulfillment_status === "Order Items Picked Up" && (
            <div className="bg-white rounded-3 mb-4 shadow-sm">
              <div className="flex flex-row justify-between p-4 border-b border-gray-100">
                <p className="font-semibold">{order.order_number}</p>
                <span className="bg-red-500 text-white text-xs px-3 py-1.5 rounded-4 uppercase">
                  Shipped
                </span>
              </div>

              <div className="flex flex-row items-center p-4">
                <img src={Shipped} className="w-16 h-16 mr-4" alt="shipped" />
                <div>
                  <p className="text-lg font-semibold">Order Shipped!</p>
                  <p className="text-sm text-gray-600">
                    You have given the items to the delivery partner.
                  </p>
                </div>
              </div>
            </div>
          )}

        {/* Returning */}
        {order?.vendor_status === "Returning" && (
          <div className="bg-white rounded-3 mb-4 shadow-sm">
            <div className="flex flex-row justify-between p-4 border-b">
              <p className="font-semibold">#{order.quotation_number}</p>
              <span className="bg-red-500 text-white text-xs px-3 py-1.5 rounded-4 uppercase">
                Returned
              </span>
            </div>

            <div className="flex flex-row items-center p-4">
              <img src={BoxReturn} className="w-16 h-16 mr-4" alt="returned" />
              <div>
                <p className="text-lg font-semibold">Items Returning</p>
                <p className="text-sm text-gray-600">
                  Buyer is returning some items.
                </p>
              </div>
            </div>
          </div>
        )}

        {/*otp div*/}
        {order &&
          order.order_pickup_otp &&
          !isNaN(Number(order.order_pickup_otp)) && (
            <div className="mb-6">
              <div className="bg-white rounded-xl p-4 border border-gray-200 shadow-sm">
                <div className="flex items-center">

                  {/* LEFT SECTION */}
                  <div className="flex items-center flex-1">
                    <div>
                      <p className="text-gray-900 font-semibold text-sm">
                        Pickup Verification
                      </p>
                      <p className="text-gray-500 text-xs mt-0.5">
                        Share this OTP with the delivery executive
                      </p>
                    </div>
                  </div>

                  {/* RIGHT SECTION – OTP */}
                  <div className="flex items-center justify-center">
                    <div className="bg-gray-50 rounded-lg px-4 py-2 border border-gray-300 min-w-[90px]">
                      <p className="text-xl font-bold text-gray-900 text-center tracking-widest">
                        {order.order_pickup_otp}
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
        )}


        {/* Order Items */}
        <div className="bg-white rounded-3 mb-4 shadow-sm">
          <div className="px-4 py-3 border-b">
            <p className="text-lg font-semibold">Order Items</p>
          </div>

          {order?.categories?.map((category) => {
            const items = getItemsByCategory(category._id);
            if (!items.length) return null;

            return (
              <div key={category._id} className="mb-1">

                {/* Category Header */}
                <div className="bg-gray-50 px-2 py-2 rounded-lg">
                  <p className="text-sm font-semibold text-gray-700">
                    {category.product_category_name} ({items.length})
                  </p>
                </div>

                {/* Items */}
                {items.map((item, i) => (
                  <div
                    key={item._id}
                    className={`flex flex-row items-center p-4 ${
                      i < items.length - 1 ? "border-b" : ""
                    }`}
                  >
                    <img
                      src={
                        item.item_image
                          ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.item_image}`
                          : Default
                      }
                      className="w-12 h-12 mr-3 border rounded-md"
                      alt={item.item_name}
                    />

                    <div className="flex-1 mr-3">
                      <p className="text-sm font-medium">{item.item_name}</p>
                      <p className="text-xs text-gray-600">
                       ₹{Number(item.selling_price).toLocaleString("en-US")} × {item.quantity} qty
                      </p>
                    </div>

                    <p className="font-semibold text-gray-900">₹{Number(item.total).toLocaleString("en-US")}</p>
                  </div>
                ))}
              </div>
            );
          })}
        </div>

        {/* Delivery Details */}
        <div className="bg-white rounded-3 mb-4 shadow-sm p-4">

          <p className="text-lg font-semibold mb-3">Delivery Details</p>

          {/* Delivery Point */}
          {order?.delivery_details?.delivery_area && (
            <div>
              <div className="flex items-center text-gray-600">
                <FontAwesomeIcon icon={faLocationPin} className="text-sm" />
                <span className="ml-2 text-xs font-medium">Delivery Point</span>
              </div>

              <div className="ml-6 mt-2">
                <p className="text-xs text-gray-900">
                  {order.delivery_details.delivery_area}
                </p>

                {order?.delivery_details?.distance_in_km > 0 && (
                  <p className="text-xs mt-1">
                    {order.delivery_details.distance_in_km} km from your store
                  </p>
                )}
              </div>
            </div>
          )}

          <div className="my-3 border-b" />

          {/* Delivery Type */}
          <div className="flex items-center">
            <FontAwesomeIcon icon={faTruck} className="text-sm text-gray-600" />

            <span className="ml-2 text-sm text-gray-700">
              Delivery will be done by{" "}
            </span>

            {order?.delivery_details?.IDB ? (
              <>
                <img src={BB} className="w-5 h-5 ml-1" alt="logo" />
                <span className="text-black font-bold ml-1">Brickbucket</span>
              </>
            ) : (
              <span className="text-black font-bold ml-1">
                {order?.delivery_details?.delivery_by || "Vendor"}
              </span>
            )}
          </div>

          {/* Delivery Time */}
          {deliveryTime && deliveryTime !== "0" && (
            <div className="flex items-center mt-4">
              <FontAwesomeIcon icon={faClock} className="text-sm" />
              <span className="ml-2 text-sm font-semibold">
                Estimated delivery time:
              </span>
              <span className="ml-5 text-blue-600 font-semibold">
                {deliveryTime}
              </span>
            </div>
          )}
        </div>

        {/* Bill Details */}
        <div className="bg-white rounded-3 p-4 shadow-sm mb-4">
          <p className="text-lg font-semibold mb-4">Bill Details</p>

          <div className="flex justify-between mb-3">
            <div className="flex items-center">
              <img src={ListView} className="w-5 h-5 mr-2" alt="" />
              <p className="text-sm text-gray-600">Items Total</p>
            </div>
            <p className="font-medium">₹{order?.subtotal?.toLocaleString()}</p>
          </div>

          <div className="flex justify-between mb-3">
            <div className="flex items-center">
              <img src={GST} className="w-5 h-5 mr-2" alt="" />
              <p className="text-sm text-gray-600">GST (18%)</p>
            </div>
            <p className="font-medium">₹{order?.tax_amount}</p>
          </div>

          <div className="border-b my-3" />

          <div className="flex justify-between">
            <p className="text-base font-semibold">Grand Total</p>
            <p className="text-lg font-bold text-red-500">
              ₹{(order?.subtotal + order?.tax_amount)?.toLocaleString()}
            </p>
          </div>
        </div>

        {/* Support */}
        <div className="bg-white rounded-3 p-4 shadow-sm mb-4">
          <div className="flex flex-row items-center justify-between">
            <div className="flex-1">
              <p className="text-base font-semibold">Need Help?</p>
              <p className="text-sm text-gray-600">
                Contact our Support Team
              </p>
            </div>

            <div className="flex gap-3">

              {/* Phone */}
              <button
                onClick={() => (window.location.href = `tel:${phoneNumber}`)}
                className="w-8 h-8 rounded-3 bg-blue-100 flex items-center justify-center"
              >
                <FontAwesomeIcon icon={faPhone} className="text-base text-[#2563EB]" />
              </button>

              {/* WhatsApp */}
              <button
                onClick={() =>
                  window.open(`https://wa.me/${whatsappNumber}`, "_blank")
                }
                className="w-8 h-8"
              >
                <img src={Whatsapp} className="w-full h-full" alt="whatsapp" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Upload Invoice Modal */}
      <UploadInvoiceModal
        uploadInvoicePopup={uploadInvoicePopup}
        setUploadInvoicePopup={setUploadInvoicePopup}
        bill={billData}
        order={order}
        onSuccess={fetchOrderbyId}
      />

      {/* Items Ready Modal */}
      <ItemsReadyModal
        itemsReadyPopup={itemsReadyPopup}
        setItemsReadyPopup={setItemsReadyPopup}
        orderId={order?._id}
        onSuccess={fetchOrderbyId}
      />

      <OrderItemsAvailabilityBottomSheet
        isOpen={showSheet}
        onClose={() => setShowSheet(false)}
        items={order.items}
        isSubmitting={isSubmitting}
        onSubmit={handleAvailabilitySubmit}
      />

      {/* Custom Popup */}
      <CustomPopup
        visible={showCustomPopup}
        onClose={() => setShowCustomPopup(false)}
        title={popupMessage.title}
        message={popupMessage.message}
        type={popupMessage.type}
      />

      {/* OTP Modal */}
      {isOTPModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-4 w-full max-w-sm mx-4">

            <div className="p-6 text-center border-b relative">
              <button
                onClick={closeOTPModal}
                className="absolute top-4 right-4"
              >
                <FontAwesomeIcon icon={faTimes} color="#666" />
              </button>

              <p className="text-xl font-semibold mb-2">Enter OTP</p>
              <p className="text-sm text-gray-600">
                Enter the 4-digit OTP provided by the delivery partner.
              </p>
            </div>

            <div className="p-6 flex flex-col items-center">
              <div className="flex gap-4 mb-8">
                {otpValues.map((value, index) => (
                  <input
                    key={index}
                    ref={otpRefs[index]}
                    className="w-12 h-12 border-2 border-gray-200 rounded text-center text-lg font-semibold"
                    maxLength={1}
                    value={value}
                    onChange={(e) =>
                      handleOTPChange(index, e.target.value)
                    }
                  />
                ))}
              </div>

              <button
                onClick={handleVerifyOTP}
                disabled={isVerifyingOTP || otpValues.join("").length !== 4}
                className={`rounded-2 py-3 px-8 w-full ${
                  otpValues.join("").length !== 4
                    ? "bg-gray-200 text-gray-400"
                    : "bg-red-500 text-white"
                }`}
              >
                {isVerifyingOTP ? "Verifying..." : "Verify OTP"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delivery Validation Modal */}
      <DeliveryValidationModal
        visible={showValidationModal}
        onClose={() => setShowValidationModal(false)}
      />
    </div>
     )}
  </>
  );
};
  export default OrderDetails;